// Landing-page promo bands -> offer modal.
//
// The modal body is the SAME lead-form partial the hero renders (client
// request: one form for the whole page), so the only per-band difference is
// which band produced the lead. Each trigger carries data-dia-source; copy it
// into the form's hidden `source` input when the modal opens, so attribution
// still distinguishes "Schimb" from "Credit" without duplicating the form.
import { qs, delegate } from '../lib/dom.js';

export function initDiaOfferModal() {
  const dlg = qs('#dia-offer-modal');
  if (!dlg) return;

  // Delegated: the bands are server-rendered, but keep this resilient to a
  // band being re-rendered later.
  delegate(document, 'click', '[data-modal="dia-offer-modal"][data-dia-source]', (e, trigger) => {
    const src = trigger.getAttribute('data-dia-source') || '';
    const field = qs('input[name="source"]', dlg);
    if (field && src) field.value = src;
  });
}
